// The page → filter rules are shared with the API (it ignores filters a page does not offer).
import { FILTER_GROUPS } from "../../shared/tabFilters.js";

export { FILTER_GROUPS, filterKeysFor, filtersFor } from "../../shared/tabFilters.js";

/** Advanced filters in effect on a page showing `show` groups, for the drawer button's badge. */
export function advancedCount(filters, show) {
  return show.flatMap((g) => FILTER_GROUPS[g] ?? []).filter((k) => filters[k]).length + (filters.includeTest ? 1 : 0);
}
